
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1700"}},[_c('path',{attrs:{"data-name":"Rectangle 2405","fill":"none","d":"M0 0h25v20H0z"}}),_c('g',{attrs:{"data-name":"Group 1699","fill":"#3c3c3c"}},[_c('path',{attrs:{"data-name":"Path 1050","d":"M22.5 10.969h-.832V8a6.007 6.007 0 00-6-6H9.334a6.007 6.007 0 00-6 6v2.969H2.5a2.5 2.5 0 100 5h1.079A2.941 2.941 0 003.385 17a3 3 0 106 0 2.964 2.964 0 00-.193-1.031h7.228A2.964 2.964 0 0016.227 17a3 3 0 006 0 2.964 2.964 0 00-.193-1.031h.466a2.5 2.5 0 000-5zM5.334 8a4 4 0 014-4h6.334a4 4 0 014 4v2.969H5.334z"}}),_c('path',{attrs:{"data-name":"Path 1051","d":"M15.375 6.247h-3.783a1.635 1.635 0 00-1.5-1.034A1.664 1.664 0 008.461 6.9v1.158a1.663 1.663 0 001.631 1.686 1.627 1.627 0 001.469-.968h3.816a1.265 1.265 0 100-2.529z"}})])])])
          )
        }
      }
    